import React, { useState } from "react";
import { Dropdown, DropdownButton, Form } from "react-bootstrap";
import "/node_modules/flag-icons/css/flag-icons.min.css";

// List of countries with country codes and flags
const countries = [
    { code: "386", name: "Slovenia", flag: "fi fi-si", pattern: /^0([1-7]\d{1})(\d{3})(\d{3})$/, format: "$1 $2 $3" },
    { code: "385", name: "Croatia", flag: "fi fi-hr", pattern: /^0([9]\d{2})(\d{3})(\d{3})$/, format: "$1 $2 $3" },
    { code: "381", name: "Serbia", flag: "fi fi-rs", pattern: /^06([0-6])(\d{3})(\d{3})$/, format: "$1 $2 $3" },
    { code: "49", name: "Germany", flag: "fi fi-de", pattern: /^01(\d{2,3})(\d{3})(\d{3,4})$/, format: "$1 $2 $3" },
];

const CustomPhoneInput = ({ name, placeholder, value, type, onChange, error = false, errorMessage }) => {
    const [selectedCountry, setSelectedCountry] = useState(countries[0]); // Default selected country
    const [phoneNumber, setPhoneNumber] = useState("");

    const handleCountryChange = (country) => {
        setSelectedCountry(country);
        onChange(formatOutput(country.code, phoneNumber)); // Update the full phone number
    };

    const handlePhoneNumberChange = (e) => {
        let input = e.target.value.replace(/\D/g, ""); // Remove non-digit characters

        // Validate and format the number based on the selected country's pattern
        const match = input.match(selectedCountry.pattern);
        if (match) {
            const formattedInput = selectedCountry.format.replace(/\$(\d)/g, (_, groupIndex) => match[groupIndex] || "");
            setPhoneNumber(formattedInput);
            const outputNumber = formatOutput(selectedCountry.code, formattedInput);
            onChange(outputNumber); // Trigger parent handler
        } else {
            setPhoneNumber(input); // Update raw input if it doesn't match the pattern
        }
    };

    const formatOutput = (countryCode, number) => {
        // Remove white spaces and leading 0 for Slovenian numbers or others requiring it
        const sanitizedNumber = number.replace(/\s+/g, ""); // Remove all white spaces
        return `${countryCode}${sanitizedNumber}`; // Concatenate country code and sanitized number
    };

    return (
        <div className="btn-group" role="group" aria-label="Phone input" style={{ display: "flex" }}>
            <DropdownButton
                className="artur-dropdown"
                id="selectCountryDropdown"
                title={
                    <span>
                        <span className={selectedCountry.flag}></span>
                    </span>
                }
            >
                {countries.map((country) => (
                    <Dropdown.Item
                        key={country.code}
                        eventKey={country.code}
                        onClick={() => handleCountryChange(country)}
                        className="dropdown-item"
                    >
                        <span className={country.flag}></span> <small>(+{country.code})</small>
                    </Dropdown.Item>
                ))}
            </DropdownButton>

            <Form.Control
                name={name}
                placeholder={placeholder}
                tabIndex="3"
                value={phoneNumber} // Display formatted number
                type={type}
                onChange={handlePhoneNumberChange}
            />
            {error && <span className="validation-message">{errorMessage}</span>}
        </div>
    );
};

export default CustomPhoneInput;
